import ProgramPreviewContainer from './program_preview_container';

const ProgramPreview = ProgramPreviewContainer;
export default ProgramPreview;
